// extracted by mini-css-extract-plugin
export default {"acumulator":"acumulator_acumulator__C+Min"};